import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDPaper, FDPrimaryActionButton, FDStack, FDStat, FDLozenge, FDBox,
} from '@facet-wealth/design';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import MetaControl from 'Components/UI/Meta/MetaControl';
import ManagedAccountOpeningItemCardChip
  from 'Organisms/ManagedAccountOpeningItemCard/ManagedAccountOpeningItemCardChip';

const metaOverrideSet = fr.metaOverride()
  .nameOverride(['contentOne', 'startDate'], {
    _component: () => FDStat,
  }, {
    ordinal: 200,
  });

function getActionTypeLozengeColor(actionType) {
  const colorMap = {
    start: 'success',
    stop: 'error',
    update: 'info',
  };

  return colorMap[actionType] ?? 'info';
}

export default function ActivationActionCard({
  resource,
  onActionClick,
}) {
  return (
    <FDPaper width={'100%'} padding={400}>
      <FDStack direction={'column'} spacing={2} alignItems={'stretch'} justifyContent="flex-start">
        <FDStack justifyContent={'space-between'} alignItems={'flex-start'} spacing={1} direction={'column'}>
          <FDBox flex={1} maxWidth={'100%'}>
            <Text
              variant={'h4'}
              weight={'medium'}
              align={'left'}
              color={'textPrimary'}
              noWrap
              value={resource.attr('title')}
            />
          </FDBox>
          {resource.attr('subtitle') && (
            <FDBox flex={1} maxWidth={'100%'}>
              <Text
                variant={'h4'}
                weight={'medium'}
                align={'left'}
                color={'textPrimary'}
                noWrap
                value={resource.attr('subtitle')}
              />
            </FDBox>
          )}
          {resource.attr('status') !== 'completed' && <FDLozenge label={resource.attr('actionTypeDisplay')} color={getActionTypeLozengeColor(resource.attr('actionType'))} /> }
          {resource.attr('status') === 'completed' && (<ManagedAccountOpeningItemCardChip />)}
        </FDStack>
        <FDStack spacing={2} alignItems="flex-start" justifyContent="flex-start">
          <FDBox flex={1} maxWidth={'100%'}>
            <MetaControl resource={resource} attrName={'contentOne'} metaOverrideSet={metaOverrideSet} />
          </FDBox>
          <FDBox flex={1} maxWidth={'100%'}>
            {resource.attr('startDate') && <MetaControl resource={resource} attrName={'startDate'} metaOverrideSet={metaOverrideSet} />}
          </FDBox>
        </FDStack>
        {onActionClick && <FDPrimaryActionButton isFullWidth label={resource.attr('apexAccountDetailsId') ? 'Open Account' : 'Get Started'} onClick={onActionClick} />}
      </FDStack>
    </FDPaper>
  );
}

ActivationActionCard.propTypes = {
  resource: PropTypes.object.isRequired,
  onActionClick: PropTypes.func,
};

ActivationActionCard.defaultProps = {
  onActionClick: undefined,
};
